module.exports = __webpack_public_path__ + "img/app-access.05db35b1.svg";